import React from "react";
import { List, ListItem, Typography } from "@mui/material";
import useAuth from "../hooks/useAuth";

const parseTncContent = (tncContent) => {
    if (typeof tncContent === "string") {
        return tncContent
            .split("\n")
            .map((line) => line.trim().replace(/^- /, ""))
            .filter((line) => line.length > 0);
    } else if (Array.isArray(tncContent)) {
        return tncContent;
    }
    return [];
    
};

export const RenderTncContent = () => {
	const { tncContent } = useAuth();
	const bulletPoints = parseTncContent(tncContent);

	return (
		<List>
			{bulletPoints.map((point, index) => (
				<ListItem
					key={index}
					sx={{ display: "list-item", listStyleType: "disc", ml: 2 }}
				>
					<Typography variant="body1" color="textSecondary">
						{point}
					</Typography>
				</ListItem>
			))}
		</List>
	);
};